import { FRAGMENT_STATUS, isFragmentLoading } from '../features/fragmentsSlice';

/**
 * Resolves the headless-aware presentation facts shared by FragmentContent
 * (what to render, whether to announce loading state) and DrawerNavFragment
 * (which class-list branch applies) from a single (status, headless) pair,
 * so both stop independently re-deriving the same "is this a real, visible
 * mount" branching.
 *
 * @param {string} status - a FRAGMENT_STATUS value
 * @param {boolean} headless - true when this mount exists only to fetch +
 *   hydrate a widget that renders its own hidden UI, not inline content
 * @returns {{ isLoaded: boolean, isPending: boolean, isVisible: boolean }}
 */
export const resolveFragmentPresentation = (status, headless) => ({
	isLoaded: status === FRAGMENT_STATUS.LOADED,
	isPending: isFragmentLoading(status),
	isVisible: !headless
});
